import { skipToken } from "@reduxjs/toolkit/query";
import { api } from "../../state/api";
import type { AppResponse } from "../../state/api.types";
import { LockedNotice } from "../shared/LockedNotice";
import { SandboxActions } from "./SandboxActions";
import { SandboxPreview } from "./SandboxPreview";
import { SandboxStatus } from "./SandboxStatus";

type SandboxCardProps = {
  app: AppResponse;
};

export const SandboxCard = (props: SandboxCardProps) => {
  const getUser = api.useGetUserQuery(null);
  const getDebugAccount = api.useGetDebugAccountQuery(
    props.app.is_sandbox ? { appUUID: props.app.uuid } : skipToken,
  );

  if (props.app.is_sandbox && !getDebugAccount.data) {
    return null;
  }

  return (
    <div className="rounded-xl border border-secondary p-3xl">
      <div className="text-lg font-semibold">Sandbox tool</div>
      <div className="text-sm text-tertiary">
        Use your own email ({getUser.data?.email}) to preview and debug what
        your customer experiences as their account status changes.
      </div>
      {getDebugAccount.data ? (
        <div className="mt-3xl space-y-3xl">
          <div>
            <div className="mb-sm text-sm font-medium text-secondary">
              Account status
            </div>
            <SandboxStatus
              location={getDebugAccount.data.locations[0]}
              enrollment={getDebugAccount.data.enrollment}
            />
          </div>
          <div>
            <div className="mb-sm text-sm font-medium text-secondary">
              Available actions
            </div>
            <SandboxActions
              app={props.app}
              location={getDebugAccount.data.locations[0]}
              enrollment={getDebugAccount.data.enrollment}
            />
          </div>
          <div>
            <div className="mb-sm text-sm font-medium text-secondary">
              Preview customer experience
            </div>
            <SandboxPreview
              app={props.app}
              enrollment={getDebugAccount.data.enrollment}
              onClose={() => {
                getDebugAccount.refetch();
              }}
            />
          </div>
        </div>
      ) : (
        <div className="mt-3xl">
          <LockedNotice>
            Switch to a sandbox app to preview customer experiences
          </LockedNotice>
        </div>
      )}
    </div>
  );
};
